import { metricsAccountApiService } from '@logz-pkg/frontend-services';
import { MetricsStoreTypeModel } from '@logz-pkg/models';
import { Observable, useObservable } from '@logz-pkg/observable';
import { useAsyncAction } from '@logz-pkg/react-hooks';
import { useEffect } from 'react';

class M3dbAccountsStateService {
  readonly accounts = new Observable<MetricsStoreTypeModel[] | undefined>(undefined);

  fetchAccounts = async (id?: number): Promise<MetricsStoreTypeModel[] | undefined> => {
    let accounts;

    if (this.accounts.get() !== undefined) {
      return this.accounts.get();
    }

    try {
      accounts = id ? metricsAccountApiService.getAccountById(id) : await metricsAccountApiService.getAllM3DB();

      this.accounts.set(accounts);
    } catch (err) {
      accounts = [];
    }

    return accounts;
  };

  clear() {
    this.accounts.set(undefined);
  }
}

export const m3dbAccountsStateService = new M3dbAccountsStateService();

export const useM3dbAccounts = () => {
  const m3dbAccounts = useObservable<MetricsStoreTypeModel[] | undefined>(m3dbAccountsStateService.accounts);
  const {
    action: fetchAccounts,
    isPending,
    error,
  } = useAsyncAction<MetricsStoreTypeModel[] | undefined>(m3dbAccountsStateService.fetchAccounts, {
    initialIsPending: true,
  });

  useEffect(() => {
    fetchAccounts();
  }, []);

  return { m3dbAccounts, isPending, error };
};
